
import { baseApi } from "../baseApi";

export const gateentryApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
    postCreateGateEntry: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.create_gate_entry`,
        method:'post',
        body:data
      })
    }),
    postSubmitGateEntry: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.submit_gate_entry`,
        method:'post',
        body:data
      })
    }),
   postGateEntry: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.get_gate_entry_list`,
        method: 'get',
      })
   }),
   //Mutation to get if the User has Gate Entry Enable in the WMS Settings
    getGateEntryEnable: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.api_utils.purchase_order.check_gate_entry_enabled`,
        method: 'POST',
        body:data
      })
    })
  }),
});

export const { usePostCreateGateEntryMutation,usePostSubmitGateEntryMutation,usePostGateEntryMutation,useGetGateEntryEnableMutation } = gateentryApi;
